import {LOAD_COMPANY_DATA, DELETE_A_COMPANY, SAVE_A_COMPANY, UPDATE_A_COMPANY,SELECT_A_COMPANY,CLEAR_A_COMPANY_ERROR_MESSAGE} from './actions';


const initialState = {
  companysArray:[],
    deleteCompanyResp:{},
    errorCMsg:{},
    saveCompanyResp:{},
    updateCompanyResp:{},
    selectedCompany:""
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_COMPANY_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case SELECT_A_COMPANY:
          return Object.assign({}, state, {
              selectedCompany: action.selectACompanyResponse
          });
      case LOAD_COMPANY_DATA:
          return Object.assign({}, state, {
              companysArray: action.companysData
          });
          case DELETE_A_COMPANY:
          return Object.assign({}, state, {
              deleteCompanyResp: action.deleteCompanyResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_COMPANY:
          return Object.assign({}, state, {
              saveCompanyResp: action.saveCompanyResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_COMPANY:
          return Object.assign({}, state, {
              updateCompanyResp: action.saveCompanyResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
